module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Altlogo",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/portalist_theportalist-color.png"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "AdTitle"
  }, [_vm._v("The Galaxy’s Greatest Newsletter"), _c('br'), _vm._v("Delivered to Your Inbox")]), _vm._v(" "), _c('h2', {
    staticClass: "AdSubhead",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Get awesome tales of fantasy and science fiction once a week. ")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "button",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "button"
  }, [_c('a', {
    attrs: {
      "href": "https://theportalist.com/newsletters/?utm_source=PORGOAAAAJ&utm_campaign=9781504040259",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "White-link-Text"
  }, [_vm._v("Sign Up Now")])])])])]), _vm._v(" "), _c('h5', {
    staticClass: "Adurl"
  }, [_vm._v("Visit us at "), _c('a', {
    attrs: {
      "href": "https://theportalist.com/newsletters/?utm_source=PORGOAAAAJ&utm_campaign=9781504040259",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Hyperlink"
  }, [_vm._v("www.theportalist.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d9076bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/portalistad.vue
// module id = 60
// module chunks = 0